import React, { useState, useEffect, useRef } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { SelectButton } from "primereact/selectbutton";
import { Dialog } from "primereact/dialog";
import { Editor } from "primereact/editor";
import { InputText } from "primereact/inputtext";
// import { Form, Field } from "react-final-form";
import { ProgressSpinner } from "primereact/progressspinner";
import { instance } from "../../api";
import "./Pagination.css"
import Pagination from "./Pagination";
export default function Pages() {
let emptyPage ={
  id: "" ,
  titre:"" ,
  contenu:"" ,
  connected:false ,
  isFaq: false,
  last_update: "",
}

  const [editPageDialog, setEditPageDialog] = useState(false);
  const [deletePageDialog, setDeletePageDialog] = useState(false);
  const [addpageDialog, setAddPageDialog] = useState(false);
  const options = ['Non', 'Oui'];
  const optionsFaq = ['Non', 'Oui'];
  const [submitted, setSubmitted] = useState(false);
  const [gexPages, setGexPages] = useState();
  const [gexPage, setGexPage] = useState(emptyPage);
  const [contenu, setContenu]=useState();
  const [idPage, setIdPage]=useState();
  const [titre, setTitre]=useState();
  const [connected, setConnected]=useState();
  const [searchText, setSearchText] = useState(""); // Stocker le texte de recherche
  const [filteredPages, setFilteredPages] = useState([]); // Stocker les pages filtrées
  const [currentPage, setCurrentPage] = useState(1);
  //const dataPerPage = 10;
  const [dataPerPage, setDataPerPage] = useState(5);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  
  const totalPages = Math.ceil((filteredPages?.length || 0) / dataPerPage);
  const lastIndex = currentPage * dataPerPage;
  const firstIndex = lastIndex - dataPerPage;
  const currentData = filteredPages?.slice(firstIndex, lastIndex) || [];

  const [isFaq, setIsFaq]=useState();
  const [globalFilter, setGlobalFilter] = useState(null);
  const toast = useRef(null);
  const toastAdd = useRef(null);
  const toastEdit = useRef(null);
  const dt = useRef(null);
  const getPages=()=> { instance
    .get(`/api/pages/`)
    .then((result) => {
      const sortedPages = result.data.sort((a, b) => {
        const dateA = new Date(a.last_update);
        const dateB = new Date(b.last_update);
        return dateB - dateA; // Sort by descending order
      });
      

      setGexPages(sortedPages);
      setFilteredPages(sortedPages); // Initialise la liste filtrée
  
    })
    .catch((error) => console.log(error)); }
  useEffect(() => {
    getPages()
  }, []);

  const addPage = (data) => {
   
    let connectedValue 
    let isFaqValue 
    if (connected==='Oui' )  connectedValue = true;  else  connectedValue = false
    if (isFaq==='Oui' )  isFaqValue = true;  else  isFaqValue = false
    instance
      .post(`/api/pages/creation`, {
        id: idPage ,
        titre: titre ,
        contenu: contenu ,
        connected:connectedValue ,
        isfaq: isFaqValue
      })
      .then(() => {
        setAddPageDialog(false);
        toastAdd.current.show({
          severity: "success",
          summary: "Ajout d'une page",
          detail: "Page Ajoutée",
          life: 3000,
        });
      });
      getPages()
      setGexPage(emptyPage);
  };
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value); // Met à jour le texte de recherche
  
    if (value.trim() === "") {
      setFilteredPages(gexPages); // Si vide, afficher toutes les pages
    } else {
      const filtered = gexPages.filter(page =>
        page.titre.toLowerCase().includes(value.toLowerCase()) ||
        page.contenu.toLowerCase().includes(value.toLowerCase())||
        page.id.toString().toLowerCase().includes(value.toLowerCase())
      );
      setFilteredPages(filtered); // Met à jour avec les résultats filtrés
    }
  };

  const editPage = (rowData) => {
     
    setIdPage(rowData.id)
    setTitre(rowData.titre)
    setContenu(rowData.contenu)
    if (rowData.isfaq ===false)
    setIsFaq("Non")
    else if (rowData.isfaq ===true) setIsFaq("Oui")
    if (rowData.connected===false)
    setConnected("Non") 
  else if (rowData.connected===true) setConnected("Oui")
    setEditPageDialog(true);
  };
  const savePage = () => {
    let connectedValue 
    let isFaqValue 
    if (connected==='Oui' )  connectedValue = true;  else  connectedValue = false
    if (isFaq==='Oui' )  isFaqValue = true;  else  isFaqValue = false
    instance
      .post(`/api/pages/update/${idPage}`, {
        id: idPage,
        titre: titre,
        contenu: contenu,
        connected: connectedValue,
        isfaq: isFaqValue,
      })
      .then((response) => {
      const updatedPage = response.data;
      setGexPages((prevPages) =>
        prevPages.map((page) => (page.id === updatedPage.id ? updatedPage : page))
      );
      setFilteredPages((prevPages) =>
        prevPages.map((page) => (page.id === updatedPage.id ? updatedPage : page))
      );
        setEditPageDialog(false);
        //getPages()
        toastEdit.current.show({
          severity: "success",
          summary: "Modification d'une page",
          detail: "Page Modifiée",
          life: 3000,
        });
      });
  };
  const confirmDeletePage = (page) => {
    setGexPage(page);
    setDeletePageDialog(true);
  };
  const DeletePage = () => {
    const id = gexPage.id;
   
    instance.delete(
      `/api/pages/delete/${id}`).then(() => {
        // Update the state to remove the deleted page
        setGexPages((prevPages) => prevPages.filter((page) => page.id !== id));
        setFilteredPages((prevPages) => prevPages.filter((page) => page.id !== id));
  
    setDeletePageDialog(false);
    toast.current.show({
      severity: "success",
      summary: "Suppression d'une page",
      detail: "Page supprimée",
      life: 3000,
    });
  })
}
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded succesBtn mr-2"
          onClick={() => editPage(rowData)}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded succesBtn"
          onClick={() => confirmDeletePage(rowData)}
        />
      </React.Fragment>
    );
  };

  const hideDeletePageDialog = () => {
    setDeletePageDialog(false);
  };
  const hideDialog = () => {
    setEditPageDialog(false);
  };

  const deletePageDialogFooter = (
    <React.Fragment>
      <Button
        label="Non"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDeletePageDialog}
      />
      <Button
        label="Oui"
        icon="pi pi-check"
        className="p-button-text"
        onClick={DeletePage}
      />
    </React.Fragment>
  );
  const PageDialogFooter = (
    <React.Fragment>
      <Button
        label="Annuler"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDialog}
      />
      <Button
        label="Enregistrer"
        icon="pi pi-check"
        className="p-button-text"
        onClick={savePage}
      />
    </React.Fragment>
  );
  const AddPageDialogFooter = (
    <React.Fragment>
      <Button
        label="Annuler"
        icon="pi pi-times"
        className="p-button-text"
        onClick={() => setAddPageDialog(false)}
      />
      <Button
        label="Enregistrer"
        icon="pi pi-check"
        className="p-button-text"
        type='submit'
        onClick={addPage}
      />
    </React.Fragment>
  );
  const header = (
    <div className="table-header">
      <h5 className="mx-0 my-1">Liste des pages </h5>
      <span className="p-input-icon-right">
        <InputText
          type="search"
          value={searchText} // Maintient le texte de recherche
          onChange={handleSearchChange} // Recherche à chaque changement
          placeholder=" Chercher..."
        />
        <i className="pi pi-search" />
      </span>
      <Button
        label="Créer"
        icon="pi pi-plus"
        className="addBtn succesBtn"
        style={{ color: '#fff', backgroundColor: '#970121' }}
        onClick={() => setAddPageDialog(true)}
      />
    </div>
  );

  // const validate = (data) => {
  //   let errors = {};

  //   if (!data.username) {
  //     errors.username = "adresse mail requise.";
  //   } else if (
  //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.username)
  //   ) {
  //     errors.username = "adresse mail invalide";
  //   }

  //   if (!data.password) {
  //     errors.password = "mot de passe requis.";
  //   }

  //   return errors;
  // };
  // const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  // const getFormErrorMessage = (meta) => {
  //   return (
  //     isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>
  //   );
  // };

  const connectedField = (rowData) => {
    const connected = rowData.connected;
   
    return String(connected);
  };
  const isFaqField = (rowData) => {
    const isFaq = rowData.isfaq;
    
    return String(isFaq);
  };
  return (
    <div className="datatable-crud">
      <Toast ref={toast} />
      <Toast ref={toastAdd} />
      <Toast ref={toastEdit} />
      <DataTable
        ref={dt}
        value={currentData} 
        dataKey="id"
        emptyMessage={ <ProgressSpinner />} 
        globalFilter={globalFilter}
        header={header}
       
        className="crudTable"
        scrollable
        scrollHeight="450px"
      >
        <Column
          field="id"
          header="ID page "
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">ID page </span>{rowData.id}
            </div>
          )}
         
        ></Column>
        <Column
          field="titre"
          header="Titre"
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">Titre </span>{rowData.titre}
            </div>
          )}
        
        ></Column>
        {/* <Column
          field="contenu"
          header="contenu"
          style={{minWidth: "12rem" , maxWidth:"20rem"}}
        ></Column> */}
        <Column
          header="Connecté"
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">Connecté </span>{connectedField(rowData)}
            </div>
          )}
        
        ></Column>
        <Column
         
          header="Faq"
          body={(rowData) => (
            <div className="table-data">
            <span className="mobile-header">Faq </span>{isFaqField(rowData)}
            </div>
          )}
          
          
        ></Column>
        <Column
  field="last_update"
  header="Dernière Mise à Jour"
  body={(rowData) => {
    const date = rowData.last_update ? new Date(rowData.last_update) : null;
    return (
      <div className="table-data">
        <span className="mobile-header">Dernière Mise à Jour </span>
        {date ? date.toLocaleDateString("fr-FR") : " "}
      </div>
    );
  }}
></Column>

        

       

        <Column
          body={actionBodyTemplate}
          exportable={false}
          header="Actions"
     
        ></Column>
      </DataTable>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        dataPerPage={dataPerPage}
        setDataPerPage={setDataPerPage}
        handlePageChange={handlePageChange}
      />
      <Dialog
        visible={editPageDialog}
        style={{ width: "650px" }}
        header="Détails de la page"
        modal
        className="p-fluid"
        footer={PageDialogFooter}
        onHide={hideDialog}
      >
       
          <div>
            <div className="field">
              <label htmlFor="idPage">id Page</label>
              <InputText id="idPage" value={idPage} disabled required />
            </div>

            <div className="field">
              <label htmlFor="name">Titre</label>
              <InputText
                id="name"
                value={titre}
                onChange={(e) => setTitre(e.target.value)}
                required
                className={classNames({
                  "p-invalid": submitted && !gexPage.titre,
                })}
              />
              {submitted && !gexPage.titre && (
                <small className="p-error">le titre requis.</small>
              )}
            </div>
            <div className="field">
              <Editor
                value={contenu}
                style={{ height: "320px" }}
                onTextChange={(e)=>setContenu(e.htmlValue)}
              />
            </div>
            <div className="field">
              <label className="mb-3">Connecté</label>
              <div className="formgrid grid">
                <div className="field-radiobutton col-6">
                  <SelectButton
                    value={String(connected)}
                    // onChange={onConnectedChange}
                    onChange={(e) => setConnected(e.target.value)}
                    options={options}
                  />
                </div>
              </div>
              <div className="field">
                <label className="mb-3">isFaq</label>
                <div className="formgrid grid">
                  <div className="field-radiobutton col-6">
                    <SelectButton
                      value={String(isFaq)}
                      onChange={(e) => setIsFaq(e.target.value)}
                      options={optionsFaq}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
      
      </Dialog>
      <Dialog
        visible={addpageDialog}
        style={{ width: "650px" }}
        header="Ajouter une page"
        modal
        className="p-fluid"
        footer={AddPageDialogFooter}
        onHide={(e) => setAddPageDialog(false)}
      >
        <div>
          <div className="field">
            <label htmlFor="id">id Page</label>
            <InputText
              id="id"
              name="id"
              onChange={(e)=>setIdPage(e.target.value)}
              // onChange={(e)=>{             
              // setGexPage({...gexPage, 
              // [e.target.name]:e.target.value })}}
            />
          </div>

          <div className="field">
            <label htmlFor="titre">Titre</label>
            <InputText
              id="titre" 
              name='titre'
              onChange={(e)=>setTitre(e.target.value)}
              // onChange={(e)=>{
              // setGexPage({...gexPage, 
              // [e.target.name]:e.target.value })}}
            
              className={classNames({
                "p-invalid": submitted && !gexPage.titre,
              })}
            />
            {submitted && !gexPage.titre && (
              <small className="p-error">le titre requis.</small>
            )}
          </div>
          <div className="field">
            <label htmlFor="contenu">Contenu</label>
            <Editor
              id="contenu"
              name="contenu"
              
              onTextChange={(e) => setContenu(e.htmlValue)} 
              
              required
              className={classNames({
                "p-invalid": submitted && !gexPage.contenu,
              })}
            />
            {submitted && !gexPage.contenu && (
              <small className="p-error">le contenu requis.</small>
            )}
          </div>

          <div className="field">
            <label className="mb-3">Connecté</label>
            <div className="formgrid grid">
              <div className="field-radiobutton col-6">
                <SelectButton name="connected" 
                value={String(connected)}
              //   onChange={(e) => {setGexPage({...gexPage, 
              // [e.target.name]:e.target.value })}}
               onChange={(e)=>setConnected(e.target.value)}
               options={options} />
              </div>
            </div>
          </div>
          <div className="field">
            <label className="mb-3">isFaq</label>
            <div className="formgrid grid">
              <div className="field-radiobutton col-6">
                <SelectButton name="isFaq" 
              value={String(isFaq)}
              onChange={(e)=>setIsFaq(e.target.value)}
               options={optionsFaq} />
              </div>
            </div>
          </div>
          
        </div>
      </Dialog>
      <Dialog
        visible={deletePageDialog}
        style={{ width: "450px" }}
        header="Confirm"
        modal
        footer={deletePageDialogFooter}
        onHide={hideDeletePageDialog}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {gexPage && (
            <span>
              Voulez-Vous supprimer la page <b>{gexPage.titre}</b>?
            </span>
          )}
        </div>
      </Dialog>
    </div>
  );
}
